module.exports = __webpack_public_path__ + "img/txt.545ffe50.png";